var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-picker-global",
      class: { mini: _vm.mini, isOpen: _vm.showPicker },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formatedSelected,
            expression: "formatedSelected",
          },
          {
            name: "inputmask",
            rawName: "v-inputmask",
            value: _vm.maskFromTrad,
            expression: "maskFromTrad",
          },
        ],
        ref: "date",
        staticClass: "date-picker-handler",
        class: _vm.inputclass,
        attrs: { type: "text" },
        domProps: { value: _vm.formatedSelected },
        on: {
          click: _vm.handlePicker,
          keyup: _vm.handleInput,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formatedSelected = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.unhandlePicker,
              expression: "unhandlePicker",
            },
          ],
          staticClass: "date-picker-container",
          class: [_vm.constructPositionClasses, { show: _vm.showPicker }],
        },
        [
          _c("div", { staticClass: "date-display" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.formatedDisplay) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "date-picker",
            attrs: { id: "picker-" + _vm._uid },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }